'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier from "./com.raquo.laminar.modifiers.-Modifier.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__($thiz, tagName) {
  $thiz.dz = tagName;
  $thiz.cu = $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.r3();
  $thiz.cQ();
  return $thiz;
}
export { $ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__ as $ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__ };
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent.prototype = $p;
$p.ec = (function() {
  if ((!this.dW)) {
    this.dV = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag(this.dz, $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
    this.dW = true;
    this.dz = null;
  }
  return this.dV;
});
$p.aP = (function(componentMods, laminarMods) {
  var el = this.ec().u($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
  componentMods.a6(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1) => {
    _$1.j(this).dL(el);
  })));
  laminarMods.a6(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2) => {
    _$2.dL(el);
  })));
  return el;
});
